/* eslint-disable react-hooks/exhaustive-deps */
import Documents from 'components/documents/Documents';
import Layout from 'components/layout/Layout';
import { CONFIGURE_VIEW } from 'constants/constants';
import { useEffect } from 'react';
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import { useDispatch, useSelector } from 'react-redux';
import { setActiveTab } from 'store/home/homeMyViewSlice';
import classes from './Home.module.scss';
import ViewLayout from './views/ViewLayout';

const Home = () => {
  const dispatch = useDispatch();
  const { activeTab } = useSelector((state) => state?.HomeMyView);

  useEffect(() => {
    window.scrollTo(0, 0);
    return () => {
      dispatch(setActiveTab('myView'));
    };
  }, []);

  const onChangeTabHandler = (k) => {
    dispatch(setActiveTab(k));
  };

  const TabContent = ({ eventKey, title, className }) => {
    return (
      <span className='d-flex'>
        <i
          className={`icon icon__${className}${
            activeTab === eventKey ? '-active' : ''
          }`}
        />
        {title}
      </span>
    );
  };

  return (
      <Layout showRighSideBar={true}>
        <div className='gne-container'>
          <Tabs
            id='homeView'
            activeKey={activeTab}
            onSelect={onChangeTabHandler}
            unmountOnExit={true}
            mountOnEnter={true}
            className={`mb-3 ps-0 ${classes.stickyTab}`}>
            <Tab
              eventKey='myView'
              title={
                <TabContent
                  eventKey='myView'
                  title={'My Views'}
                  className={'my-view'}
                />
              }>
              <ViewLayout page={CONFIGURE_VIEW.myView} />
            </Tab>
            <Tab
              eventKey='myDefault'
              title={
                <TabContent
                  eventKey='myDefault'
                  title={'Sample Views'}
                  className={'my-default'}
                />
              }>
              <ViewLayout page={CONFIGURE_VIEW.myDefault} />
            </Tab>
            <Tab
              eventKey='myDocs'
              title={
                <TabContent
                  eventKey='myDocs'
                  title={'Documents'}
                  className={'my-view-documents'}
                />
              }>
              <Documents />
            </Tab>
          </Tabs>
        </div>
      </Layout>
  );
};

export default Home;
